import {
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  Input,
  OnInit,
  Optional,
  Renderer2,
  Self,
} from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  FormGroupDirective,
  NgControl,
} from '@angular/forms';
import { NUMERIC_VALIDATORS } from 'src/app/core/validators/validators';

@Component({
    selector: 'gl-input, input[normal-input], input[number-input], textarea[textarea-input]',
    templateUrl: './input.component.html',
    styleUrls: ['./input.component.scss'],
    standalone: false
})
export class InputComponent implements ControlValueAccessor, OnInit {
  public INPUT_ATTRIBUTES: string[] = ['normal-input', 'number-input', 'textarea-input'];
  @Input() public numericType: 'integer' | 'float' | 'floatNeg';
  @HostBinding('class.whiteText') @Input() public whiteText: string;
  @HostBinding('class.disabled') public isDisabled;

  constructor(
    @Optional() @Self() public ngControl: NgControl,
    @Optional() public parentFormGroup: FormGroupDirective,
    private renderer: Renderer2,
    private elRef: ElementRef<HTMLInputElement>,
  ) {
    ngControl.valueAccessor = this;
  }

  @HostBinding('class.error') get submitted() {
    return this.parentFormGroup?.submitted && this.ngControl?.invalid;
  }

  @HostBinding('blur') public onTouched() {
    return;
  }

  public ngOnInit() {
    this.INPUT_ATTRIBUTES.forEach((attr) => {
      if (this.hasAttribute(attr)) {
        this.elRef.nativeElement.classList.add(attr);
      }
    });

    if (this.numericType) {
      this.setValidators(this.ngControl.control);
    }
  }

  @HostListener('input', ['$event']) public onInput(event) {
    let value;
    if (this.numericType) {
      value = event.target.value.replace(',', '.');
    } else {
      value = event.target.value;
    }
    this.elRef.nativeElement.value = value;
    this.propagateChange(value);
  }

  public registerOnChange(fn: any): any {
    this.propagateChange = fn;
  }

  public registerOnTouched(fn) {
    this.onTouched = fn;
  }

  public writeValue(value: any): void {
    this.elRef.nativeElement.value = value;
  }

  public setValue(value: any) {
    this.elRef.nativeElement.value = value;
    this.propagateChange(value);
  }

  public setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
    this.renderer.setProperty(this.elRef.nativeElement, 'disabled', isDisabled);
  }

  public hasAttribute(attribute: string) {
    return this.elRef.nativeElement.hasAttribute(attribute);
  }

  private propagateChange = (_: any) => undefined;

  private setValidators(control: AbstractControl) {
    if (this.numericType === 'float') {
      const validators = control.validator
        ? [control.validator, NUMERIC_VALIDATORS.float]
        : NUMERIC_VALIDATORS.float;
      control.setValidators(validators);
    } else if (this.numericType === 'integer') {
      const validators = control.validator
        ? [control.validator, NUMERIC_VALIDATORS.integer]
        : NUMERIC_VALIDATORS.integer;
      control.setValidators(validators);
    } else if (this.numericType === 'floatNeg') {
      const validators = control.validator
        ? [control.validator, NUMERIC_VALIDATORS.floatNeg]
        : NUMERIC_VALIDATORS.floatNeg;
      control.setValidators(validators);
    }
  }
}
